import { render, staticRenderFns } from "./applicationVersionRule.vue?vue&type=template&id=3e96bb3e&scoped=true"
import script from "./applicationVersionRule.vue?vue&type=script&lang=js"
export * from "./applicationVersionRule.vue?vue&type=script&lang=js"
import style0 from "./applicationVersionRule.vue?vue&type=style&index=0&id=3e96bb3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e96bb3e",
  null
  
)

export default component.exports